{
  "version": "v4.0.0",
  "name": "Burn",
  "bytecodeTemplate": "0101030000000c{1}{0}{2}a3{1}{2}0e0e{0}010f1818",
  "fieldsSig": {
    "names": [
      "tokenPair",
      "sender",
      "liquidity"
    ],
    "types": [
      "TokenPair",
      "Address",
      "U256"
    ],
    "isMutable": [
      false,
      false,
      false
    ]
  },
  "functions": [
    {
      "name": "main",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": []
    }
  ]
}